import { asesoriasService } from '@/services/asesorias.service';
import { useCallback, useEffect, useState } from 'react';

export interface UseAsesoriaHistorialDetalleResult {
  data: Awaited<ReturnType<typeof asesoriasService.getById>>['asesoria'] | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useAsesoriaHistorialDetalle(nit: string | null, asesoriaId: number | null): UseAsesoriaHistorialDetalleResult {
  const [data, setData] = useState<UseAsesoriaHistorialDetalleResult['data']>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchDetalle = useCallback(async () => {
    if (!nit || !asesoriaId) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      console.log('Fetching asesoria detail:', { nit, asesoriaId, endpoint: `/empresas/${nit}/asesorias/${asesoriaId}` });
      const response = await asesoriasService.getById(asesoriaId, nit);
      if (response.success) {
        setData(response.asesoria);
      } else {
        setError('Error al cargar el detalle de la asesoría');
      }
    } catch (err) {
      console.error('Error fetching asesoria detail:', err);
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('Error al cargar el detalle de la asesoría');
      }
    } finally {
      setIsLoading(false);
    }
  }, [nit, asesoriaId]);

  useEffect(() => {
    fetchDetalle();
  }, [fetchDetalle]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchDetalle,
  };
}
